import { useEffect, useState } from "react";
import { ElevateLeadershipContents } from "@/components/training/ElevateLeadershipContents";
import { ELEVATE_CORE_SLIDE_IDS, ELEVATE_REFERENCES, ELEVATE_MINDSET_PATH } from "@/data/elevateLeadershipTeaching";
import { S2PElevateDeck } from "@/pages/S2PElevateAI";
import { ElevateLeadershipVisual } from "@/components/training/ElevateLeadershipVisual";
import { ELEVATE_LEADERSHIP_VISUALS } from "@/data/elevateLeadershipVisuals";
import {
  ELEVATE_LEADERSHIP_PROGRAM, type ElevateLeadershipSlide,
} from "@/data/elevateLeadership";
import "./Elevate.css";

const teachingProgram = {
  ...ELEVATE_LEADERSHIP_PROGRAM,
  slides: ELEVATE_LEADERSHIP_PROGRAM.slides.map(slide => ELEVATE_REFERENCES[slide.id]
    ? { ...slide, eyebrow: `Session ${slide.session} · Optional reference` } : slide),
};

const Elevate = () => {
  const [coreOnly, setCoreOnly] = useState(true);
  const [pdfExport, setPdfExport] = useState(false);
  useEffect(() => {
    setPdfExport(new URLSearchParams(window.location.search).get("export") === "pdf");
  }, []);
  return (
  <div className="elevate-leadership" data-pdf-export={pdfExport || undefined}>
    <S2PElevateDeck
      program={teachingProgram}
      config={{
        storageNamespace: pdfExport ? "elevate-leadership-pdf-v7" : "elevate-leadership-v7",
        analyticsVariant: "elevate-leadership",
        seoTitle: "People Transformation in the World of AI: Serve2Perform ELEVATE",
        seoDescription: "A five-session leadership workshop on AI business literacy, people and organizational implications, change management, sponsors and champions, and sustained AI practices.",
        seoKeywords: ["ELEVATE", "Serve2Perform", "AI leadership", "AI change management", "AI governance", "AI readiness", "ADKAR", "Kotter"],
        coverTitle: "People Transformation",
        coverAudience: "in the World of AI",
        coverEyebrow: "Serve2Perform ELEVATE · Five-session leadership workshop",
        showCoverLogo: false,
        showNavigationFooter: false,
        showContentsMenu: false,
        brandHref: ELEVATE_MINDSET_PATH,
        slideBasePath: ELEVATE_MINDSET_PATH,
        brandLinkLabel: "Serve2Perform ELEVATE leadership workshop",
        contentsTitle: "The leadership journey",
        contentsEyebrow: "Serve2Perform ELEVATE · People transformation",
        finishEyebrow: "Putting this to work",
        finishBulletsLabel: "Fictional briefing example",
        finishCtaHref: "/s2p-elevate-ai",
        finishCtaLabel: "Continue to tools & workflows",
        guideHref: null,
      }}
      navigationSlideIds={!pdfExport && coreOnly ? ELEVATE_CORE_SLIDE_IDS : undefined}
      navigationLabel={coreOnly ? "Core path" : "All slides"}
      renderContents={(navigation) => <ElevateLeadershipContents {...navigation} coreOnly={coreOnly} setCoreOnly={setCoreOnly} />}
      renderSlide={(slide) => {
        const visual = ELEVATE_LEADERSHIP_VISUALS[slide.id];
        return visual ? <ElevateLeadershipVisual key={slide.id} slide={slide as ElevateLeadershipSlide} visual={visual} /> : null;
      }}
    />
  </div>
  );
};

export default Elevate;
